import React, { useState } from 'react';

const videos = [
  { title: 'Full Service Replay', meta: 'Watch · 1hr 45min', featured: true },
  { title: 'Testimonies — Lives Changed', meta: 'Watch · 8min' },
  { title: 'The Altar Call Moment', meta: 'Watch · 12min' },
  { title: 'Worship Night Highlights', meta: 'Watch · 6min' },
  { title: 'Behind The Scenes', meta: 'Watch · 4min' },
];

export default function Media() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="media" style={{ padding: '120px 64px', background: 'var(--black)' }}>
      <style>{`
        @media(max-width:900px){ #media{padding:80px 24px!important;} .media-grid{grid-template-columns:1fr!important;} .media-featured{min-height:240px!important;} }
        .media-thumb-inner { transition: transform 0.6s ease; }
        .media-item-wrap:hover .media-thumb-inner { transform: scale(1.04); }
      `}</style>

      <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>From Previous Events</p>
      <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 24 }}>
        SEE WHAT<br />HAPPENS WHEN<br />GOD MOVES
      </h2>
      <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 64px' }} />

      <div className="media-grid reveal" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr', gridTemplateRows: 'auto auto', gap: 4 }}>
        {videos.map((v, i) => (
          <div key={i}
            className="media-item-wrap"
            style={{ gridRow: i === 0 ? 'span 2' : undefined, background: 'var(--ash-mid)', overflow: 'hidden', cursor: 'pointer' }}
            onMouseEnter={() => setHovered(i)}
            onMouseLeave={() => setHovered(null)}>
            <div className="media-thumb-inner" style={{
              aspectRatio: i === 0 ? undefined : '16/9',
              minHeight: i === 0 ? 440 : undefined,
              height: i === 0 ? '100%' : undefined,
              background: `linear-gradient(135deg, rgba(26,22,18,1) 0%, rgba(200,68,10,${0.08 + i * 0.04}) 100%)`,
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              position: 'relative',
            }}>
              <div style={{
                width: i === 0 ? 64 : 44, height: i === 0 ? 64 : 44,
                border: `1px solid ${hovered === i ? 'var(--ember)' : 'rgba(245,240,232,0.25)'}`,
                borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: i === 0 ? 20 : 14, color: 'var(--white)',
                background: hovered === i ? 'rgba(200,68,10,0.2)' : 'transparent',
                transition: 'all 0.3s', position: 'relative', zIndex: 1,
              }}>▶</div>
              {i === 0 && (
                <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, padding: 24, background: 'linear-gradient(0deg,rgba(8,8,8,0.9),transparent)' }}>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: 28, color: 'var(--white)' }}>FULL SERVICE REPLAY</div>
                  <div style={{ fontSize: 10, color: 'var(--ember)', letterSpacing: '0.2em', textTransform: 'uppercase', marginTop: 4 }}>Most Recent Event</div>
                </div>
              )}
            </div>
            <div style={{ padding: '16px 20px' }}>
              <div style={{ fontFamily: 'var(--font-body)', fontSize: 14, fontWeight: 500, color: 'var(--white)', marginBottom: 4 }}>{v.title}</div>
              <div style={{ fontSize: 11, letterSpacing: '0.12em', color: 'rgba(245,240,232,0.3)', textTransform: 'uppercase' }}>{v.meta}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
